import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

import { TimeagoModule } from 'ngx-timeago';

@Component({
  selector: 'app-welcome',
  imports: [TimeagoModule,],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.css'
})
export class WelcomeComponent implements OnInit {


    private _httpClient = inject(HttpClient);

    systemCheck = 'Checking System...';
    patientCheck = 'Checking Patient...';
    cateringCheck = 'Checking Catering...';
    inventoryCheck = 'Checking Inventory...';

    baseAddress = environment.isLocal ? '' : environment.api.baseAddress;

    async ngOnInit() {
        await this.performChecks();
    }

    async performChecks() {
        try{
            await this._httpClient.get( this.baseAddress + environment.api.system.healthCheck).toPromise();
            this.systemCheck = "System OK";
        } catch(err){
            this.systemCheck = "System Error";
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.patient.healthCheck).toPromise();
            this.patientCheck = "Patient OK";
        } catch(err){
            this.patientCheck = "Patient Error";
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.catering.healthCheck).toPromise();
            this.cateringCheck = "Catering OK";
        } catch(err){
            this.cateringCheck = "Catering Error";
        }

        try{
            await this._httpClient.get(this.baseAddress + environment.api.inventory.healthCheck).toPromise();
            this.inventoryCheck = "Inventory OK";
        } catch(err){
            this.inventoryCheck = "Inventory Error";
        }
    }

    goHome() {
        location.href = location.origin;
    }


}
